import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function DeleteCustomerDialog({ customer, onOpenChange, onDeleted }) {
  const doDelete = async () => {
    try {
      const { data } = await api.delete(`/customers/${customer.id}`);
      const r = data.removed || {};
      toast.success(`${customer.name} deleted (${r.jobs || 0} jobs, ${r.quotes || 0} quotes, ${r.estimates || 0} estimates, ${r.invoices || 0} invoices removed)`);
      onOpenChange(false);
      onDeleted?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not delete customer");
    }
  };

  return (
    <AlertDialog open={!!customer} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="delete-customer-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {customer?.name}?</AlertDialogTitle>
          <AlertDialogDescription>
            This permanently removes the customer along with all of their jobs, quotes, estimates and invoices. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-delete-customer">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-delete-customer" onClick={doDelete} className="bg-destructive hover:bg-destructive/90">Delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
